import { History } from "history";
import { Action } from "../../../libs/redux/action";
import {
    PAGE_CLOSE_GENERIC_ERROR_MODAL,
    PAGE_NAVIGATE_TO,
    PAGE_OPEN_GENERIC_ERROR_MODAL,
    PAGE_SAVE_HISTORY_AND_PARAMS,
    PAGE_SET_CHANNELS,
    PAGE_SET_DISTRIBUTION_CODE,
    PAGE_SET_IS_STARTED_FLOW,
    PAGE_VALIDATE_CHANNELS,
} from "../constants";
import { PageState } from "../state";

export class PageSaveHistoryAndParams extends Action<
    { history: History; query: Record<string, string> },
    PageState
> {
    readonly type = PAGE_SAVE_HISTORY_AND_PARAMS;
    reducer(state: PageState): PageState {
        return {
            ...state,
            ...this.payload,
        };
    }
}

export class PageNavigateTo extends Action<string, PageState> {
    readonly type = PAGE_NAVIGATE_TO;
    reducer(state: PageState): PageState {
        return {
            ...state,
            currentPath: this.payload,
            previouysPath: state.currentPath,
        };
    }
}

export class PageOpenGenericErrorModal extends Action<string, PageState> {
    readonly type = PAGE_OPEN_GENERIC_ERROR_MODAL;
    reducer(state: PageState): PageState {
        return {
            ...state,
            genericErrorModal: {
                opened: true,
            },
        };
    }
}

export class PageCloseGenericErrorModal extends Action<string, PageState> {
    readonly type = PAGE_CLOSE_GENERIC_ERROR_MODAL;
    reducer(state: PageState): PageState {
        return {
            ...state,
            genericErrorModal: {
                opened: false,
            },
        };
    }
}
export class PageSetChannelsAction extends Action<
    PageState["channels"],
    PageState
> {
    readonly type = PAGE_SET_CHANNELS;
    reducer(state: PageState): PageState {
        return {
            ...state,
            channels: this.payload,
        };
    }
}
export class PageValidateChannelsAction extends Action<void, PageState> {
    readonly type = PAGE_VALIDATE_CHANNELS;
    reducer(state: PageState): PageState {
        return state;
    }
}

export class PageSetDistributionCodeAction extends Action<string, PageState> {
    readonly type = PAGE_SET_DISTRIBUTION_CODE;
    reducer(state: PageState): PageState {
        return {
            ...state,
            channels: {
                ...state.channels,
                distributionCode: this.payload,
            },
        };
    }
}

export class PageSetIsStartedFlow extends Action<boolean, PageState> {
    readonly type = PAGE_SET_IS_STARTED_FLOW;
    reducer(state: PageState): PageState {
        return {
            ...state,
            isStartedFlow: this.payload,
        };
    }
}
